import { Box, type BoxProps } from '@mui/material';
import { Link } from '@tanstack/react-router';
import { type FC, lazy, Suspense } from 'react';
import type { AppTheme } from 'types/models';

type Props = BoxProps & {
  disabledLink?: boolean;
  appTheme?: AppTheme;
};

const logoImports = {
  apotheo: lazy(() => import('assets/logos/apotheo.svg?react')),
  faks: lazy(() => import('assets/logos/faks.svg?react')),
  giphar: lazy(() => import('assets/logos/giphar.svg?react')),
  laf: lazy(() => import('assets/logos/laf.svg?react')),
  pharmactiv: lazy(() => import('assets/logos/pharmactiv.svg?react')),
  pharmavie: lazy(() => import('assets/logos/pharmavie.svg?react')),
  phr: lazy(() => import('assets/logos/phr.svg?react')),
  reseau_sante: lazy(() => import('assets/logos/reseauSante.svg?react')),
} as const;

const logoConfig = {
  apotheo: { title: 'Apothéo by Faks' },
  giphar: { title: 'Giphar by Faks' },
  laf: { title: 'Laf Trade by Faks' },
  phr: { title: 'Pharmacie Reference by Faks' },
  pharmactiv: { title: 'Pharmactiv by Faks' },
  reseau_sante: { title: 'Réseau Santé by Faks' },
  pharmavie: { title: 'Pharmavie by Faks' },
  faks: { title: 'Faks', width: 85, height: 'auto', ml: 2, mr: 1 },
} as const;

const Logo: FC<Props> = ({ disabledLink = false, sx, appTheme }) => {
  const theme = appTheme || 'faks';
  const LogoComponent = logoImports[theme];
  const config = logoConfig[theme];

  const logo = (
    <Suspense fallback={<Box sx={{ ...config, ...sx }} />}>
      <Box
        component={LogoComponent}
        title={config.title}
        sx={{ display: 'block', ...config, ...sx }}
      />
    </Suspense>
  );

  if (disabledLink) {
    return logo;
  }

  return <Link to="/">{logo}</Link>;
};

export default Logo;
